/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import Form from '../../../../components/Form';
import Modal, { ModalHeader } from '../../../../components/Modal';
import { ORG_CD_TYPE, SCRAPING_STATE, SVC_CD_TYPE } from '../../../../constants/SCRAPING_DATA';
import useForm from '../../../../hooks/useForm';
import { translation } from '../../../../utils/translator';


const ScrapingHistoryDetailModal = ({
  isOpen,
  setIsOpen,
  data,
}) => {
  const [fields] = useState([
    {
      title: '결과',
      key: 'response',
      type: 'textarea',
      required: true,
      height: '500px',
      readOnly: true,
    }
  ])

  const {
    form,
  } = useForm(
    {
      response: data.response
    }
  );

  const cancel = () => {
    setIsOpen(false)
  }

  return (
    <Modal isOpen={isOpen} close={cancel}>
      <div className="passivity-scraping-detail">
        <ModalHeader>
          {`${translation(ORG_CD_TYPE, data.orgCd)} ${translation(SVC_CD_TYPE, data.svcCd)} 스크래핑 ${translation(SCRAPING_STATE, data.state)}`}
        </ModalHeader>
        <Form
          fields={fields}
          form={form}
          cancel={cancel}
        />
      </div>
    </Modal>
  );
}

export default ScrapingHistoryDetailModal